import { connect } from "react-redux";

import { RootState } from "@app/store/rootReducer";

import EditNotesPanel from "../../components/EditNotesPanel";
import { createDealNote, deleteDealNote, fetchNotes, updateDealNote } from "../store/actions";
import {
  getDealNoteDeleteLoadingIds,
  getDealNoteUpdateLoadingIds,
  getNotesFilter,
  getNotesSort,
  getNotesTotal,
  isDealNoteCreateLoading,
} from "../store/selectors";

const mapStateToProps = (state: RootState) => ({
  createLoading: isDealNoteCreateLoading(state),
  deleteLoadingIds: getDealNoteDeleteLoadingIds(state),
  filter: getNotesFilter(state),
  sort: getNotesSort(state),
  total: getNotesTotal(state),
  updateLoadingIds: getDealNoteUpdateLoadingIds(state),
});

const mapDispatchToProps = {
  onChangeNote: updateDealNote.request,
  onCreateNote: createDealNote.request,
  onDeleteNote: deleteDealNote.request,
  onFetchNotes: fetchNotes.request,
};

const Notes = connect(mapStateToProps, mapDispatchToProps)(EditNotesPanel);
export default Notes;
